import { ListItem, DcuplGlobalQueryOptions, ChangeDetector, generateKey, trigger } from '@dcupl/common';

import { DcuplList } from '../list';

import { DcuplApi } from './dcupl-api';

export class ListsController {
  private lists: DcuplList[] = [];

  constructor(
    private dcuplInstance: DcuplApi<any>,
    protected cdRef: ChangeDetector,
  ) {}

  public get(listKey: string): DcuplList | undefined {
    if (listKey) {
      return this.lists.find((list) => list.key === listKey);
    }
    return undefined;
  }

  public getAll(options?: { modelKey: string }): DcuplList[] {
    if (!options) return this.lists;
    return this.lists.filter((list) => list.modelKey === options?.modelKey);
  }

  public destroy(options?: { listKey?: string; modelKey?: string }): void {
    if (!options) {
      this.lists.forEach((list) => list['_destroy']());
      this.lists = [];
    } else if (options.listKey) {
      const idx = this.lists.findIndex((list) => list.key === options.listKey);
      if (idx > -1) {
        this.lists[idx]!['_destroy']();
        this.lists.splice(idx, 1);
      }
    } else if (options.modelKey) {
      this.lists.forEach((list, idx) => {
        if (list.modelKey === options.modelKey) {
          list['_destroy']();
          this.lists.splice(idx, 1);
        }
      });
    }
  }

  @trigger({
    scope: 'global',
    type: 'list_created',
    connectMessage: true,
  })
  public create<ListType>(options: {
    modelKey: string;
    listKey?: string;
    listItemKeys?: string[];
    query?: DcuplGlobalQueryOptions<ListItem>;
  }): DcuplList {
    options.listKey = options.listKey || generateKey();

    const cdRef = new ChangeDetector();

    cdRef._init({
      cdRefKey: options.listKey!,
      parentCd: this.dcuplInstance['cdRef'],
      dcuplInitOptions: this.dcuplInstance.initOptions,
      analyticsController: this.dcuplInstance['analyticsController'],
    });

    const list = new DcuplList<ListType & ListItem>(this.dcuplInstance, cdRef);

    list['init'](options);

    this.lists.push(list);

    return list as DcuplList<ListType>;
  }
}
